import { CptySettlementTypeEnum, formatCptySettlementType, IconName, type FilterableProperty } from '@talos/kyoko';
import { useMemo } from 'react';

export function useCptySettlementTypeFilter(): FilterableProperty {
  return useMemo(
    () => ({
      key: 'CptySettlementTypes',
      label: 'Settle Type',
      icon: IconName.Cash,
      options: [CptySettlementTypeEnum.Cash, CptySettlementTypeEnum.InKind],
      getOptionLabel: formatCptySettlementType,
    }),
    []
  );
}
